var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKucoinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40226 7L8.55968 11.1574L11.1643 8.55277C11.6151 8.15206 12.3665 8.15206 12.8173 8.60286C13.2681 9.05367 13.2681 9.75492 12.8674 10.2558L9.36111 13.6619C8.91031 14.1127 8.15897 14.1127 7.70816 13.6619L2.69922 8.65295V11.6583C2.69922 12.3095 2.14823 12.8605 1.49707 12.8605C0.845906 12.8605 0.294922 12.3095 0.294922 11.6583V2.39177C0.294922 1.74061 0.845906 1.18962 1.49707 1.18962C2.14823 1.18962 2.69922 1.74061 2.69922 2.39177V5.34705L7.70816 0.338104C8.15897 -0.112701 8.91031 -0.112701 9.36111 0.338104L12.8173 3.79427C13.218 4.24508 13.218 4.99642 12.7672 5.44723C12.3164 5.89803 11.6151 5.89803 11.1142 5.49732L8.50959 2.89266L4.40226 7ZM8.55968 5.84794C8.05879 5.84794 7.65807 6.14848 7.45771 6.59929C7.25736 7.05009 7.35753 7.55098 7.70816 7.90161C8.05879 8.25224 8.55968 8.35241 9.01049 8.15206C9.46129 7.9517 9.76183 7.55098 9.76183 7.05009C9.76183 6.74955 9.66165 6.44902 9.4112 6.19857C9.16076 5.94812 8.86022 5.84794 8.55968 5.84794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoinDark);
export default __webpack_public_path__ + "static/media/kucoinDark.b92ed7e6c41bbccbdc518bcfc1091e9e.svg";
export { ForwardRef as ReactComponent };